import { DeclarationDrBase } from './declaration-dr.base.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationSV11 extends DeclarationDrBase {
    static jsonMap = {
        // Base fields (from DeclarationDrBase)
        codeProduit: 'codeProduit',
        mention: 'mention',
        igp: 'igp',
        erreurs: { key: 'erreursList' },

        // Specific fields
        sup_rec: 'sup_rec',
        vol_app: 'vol_app',
        vol_cree: 'vol_cree',
        vol_dplc: 'vol_dplc',
        vol_vsi: 'vol_vsi',
        vol_vci: 'vol_vci',

        // Nested list of details
        details: { key: 'list', converter: new (ArrayClassConverterFactory.build(DeclarationSV11))() }
    };

    sup_rec: number;
    vol_app: number;
    vol_cree: number;
    vol_dplc: number;
    vol_vsi: number;
    vol_vci: number;

    details: DeclarationSV11[] = [];
}
